module.exports = __webpack_public_path__ + "img/question-square-fill.6746b5a1.svg";